/*
 * @Author: 刘枫 
 * @Date: 2021-04-28 14:14:16 
 * @Description: 服务网点
 * @Last Modified by: liufeng
 * @Last Modified time: 2021-04-28 14:43:28
 */

<template>
  <div class="sales-net-item">
    <div @click="gomap()" class="item-title">
      <span class="item-title-txt">{{site.ftitle}}</span>
      <div class="con-rig">
        <p @click="locateClick">
          <img :src="require('../../assets/images/map.png')" alt="" width="12">
          <span>地图</span>
        </p>
      </div>
    </div>
    <div class="item-info">
      <div class="item-info-content">
        <span class="name">联系地址</span>
        <span class="value">{{site.flinkadd}}</span>
      </div>
      <div class="item-info-content">
        <span class="name">营业厅电话</span>
        <span class="value">{{site.flinkpho}}</span>
      </div>
      <div class="item-info-content">
        <span class="name">营业时间</span>
        <span class="value" v-html="site.fcontent"></span>
      </div>
    </div>
    <!-- <iframe id="mapContainer" width="100%" height="600px" frameborder=0 :src="mapsrc"></iframe> -->
  </div>
</template>
<script>
import wx from 'weixin-js-sdk';
export default {
  name: 'SalesNetItem',
  props: {
    site: Object
  },
  data() {
    return {
      signPackage: {},
      mapsrc: ''
    }
  },
  components: {
  },
  mounted() {

  },
  methods: {
    locateClick() {
      window.location.href = 'https://apis.map.qq.com/tools/poimarker?marker=coord:'
        + this.site.flinkmap
        + ';title:'
        + this.site.ftitle
        + ';addr:'
        + this.site.flinkadd
        + '&referer=myapp&key=3H3BZ-STS3P-BYPD6-VL4DK-CCBMZ-NJB6N'
    },
    gomap() {
      let wechaturl = window.location.href.split('#')[0];
      console.log(wechaturl);
      this.$http.post(this.$api.getJSApiSignature, { url: wechaturl }).then(res => {
        console.log(res.data);
        if (res.code === '000') {
          wx.config({
            debug: false,                    //开启调试模式,调用的所有api的返回值会在客户端alert出来
            appId: res.data.appId,           //公众号的唯一标识
            timestamp: res.data.timestamp,   //生成签名的时间戳
            nonceStr: res.data.nonceStr,     //生成签名的随机串
            signature: res.data.signature,   //签名
            jsApiList: ['checkJsApi', 'openLocation', 'getLocation']
          })
        }
      })
      let coord = this.site.flinkmap.split(',')
      let longitude = coord[0];
      let latitude = coord[1];
      wx.openLocation({
        latitude: longitude,
        longitude: latitude,
        name: this.site.ftitle,
        address: this.site.flinkadd,
        scale: 15
      });
    }
  }
}
</script>

<style lang="less" scoped>
.sales-net-item {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 10px 0px rgba(53, 126, 70, 0.08);
  border-radius: 4px;
  .item-title {
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    display: flex;
    align-items: center;
    .item-title-txt {
      margin-left: 6px;
    }
    .con-rig {
      flex: 1;
      text-align: right;
      margin-right: 10px;
      color: #6096f8;
      font-size: 12px;
      p {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 80px;
        float: right;
      }
      span {
        margin-left: 3px;
      }
    }
  }
  .item-info {
    padding: 10px 16px;
    .item-info-content {
      margin-bottom: 10px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333;
      display: flex;
      .name {
        padding: 0 10px;
        font-size: 10px;
        width: 63px;
        text-align: center;
        background: #6096f8;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        display: inline-table;
      }
      .value {
        width: calc(~"100% - 94px");
        color: #333;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        margin: 0 0 0 10px;
      }
    }
  }
}
/deep/p {
  margin: 0;
}
</style>